export default "__VITE_ASSET__ee53fcf0__"